import * as React from 'react';
import AiAssistantsModal from '../AiAssistantsModal';

function AiAssistantUsage({profile} :any) {
  let bonus_questions     = profile.earnings_call_usage_meter?.bonus_questions
  let premium_questions   = profile.earnings_call_usage_meter?.premium_questions
  let executive_questions = profile.earnings_call_usage_meter?.executive_questions

  let bonus_analyst_questions     = profile.financial_analyst_usage_meter?.bonus_questions
  let premium_analyst_questions   = profile.financial_analyst_usage_meter?.premium_questions
  let executive_analyst_questions = profile.financial_analyst_usage_meter?.executive_questions

  let bonus_senior_analyst_questions     = profile.senior_financial_analyst_usage_meter?.bonus_questions
  let premium_senior_analyst_questions   = profile.senior_financial_analyst_usage_meter?.premium_questions
  let executive_senior_analyst_questions = profile.senior_financial_analyst_usage_meter?.executive_questions

  let bonus_sec_filing_questions         = profile.sec_filing_usage_meter?.bonus_questions
  let premium_sec_filing_questions       = profile.sec_filing_usage_meter?.premium_questions
  let executive_sec_filing_questions     = profile.sec_filing_usage_meter?.executive_questions

  let user_plan = profile.earnings_call_usage_meter?.user_plan

  function questions_percentage(used, max) {
    return Math.round((used / max) * 100);
  }

  function bonus_questions_percentage() {
    return Math.round((bonus_questions.used / bonus_questions.max) * 100);
  }

  function premium_questions_percentage() {
    return Math.round((premium_questions.used / premium_questions.max) * 100);
  }

  function executive_questions_percentage() {
    return Math.round((executive_questions.used / executive_questions.max) * 100);
  }

  return (
    <div className="py-4 border-bottom">
      <p className="clearfix">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title"><strong>AI Usage</strong></h4>
            <p className="page-description">Questions/Tasks asked to AI Assistants. <AiAssistantsModal message="Learn more"/></p>
            <div className="template-demo">
              <div className="d-flex justify-content-between">
                <small>Saturday - bonus questions</small>
                <small>{bonus_questions.used + '/' + bonus_questions.max}</small>
              </div>
              <div className="progress progress-lg mt-2">
                <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': bonus_questions_percentage() + '%'}}>{bonus_questions_percentage() + '%'}</div>
              </div>
              <div className="d-flex justify-content-between">
                <small>Lima - bonus questions</small>
                <small>{bonus_analyst_questions.used + '/' + bonus_analyst_questions.max}</small>
              </div>
              <div className="progress progress-lg mt-2">
                <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(bonus_analyst_questions.used, bonus_analyst_questions.max) + '%'}}>{questions_percentage(bonus_analyst_questions.used, bonus_analyst_questions.max) + '%'}</div>
              </div>

              <div className="d-flex justify-content-between">
                <small>June - bonus questions</small>
                <small>{bonus_sec_filing_questions.used + '/' + bonus_sec_filing_questions.max}</small>
              </div>
              <div className="progress progress-lg mt-2">
                <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(bonus_sec_filing_questions.used, bonus_sec_filing_questions.max) + '%'}}>{questions_percentage(bonus_sec_filing_questions.used, bonus_sec_filing_questions.max) + '%'}</div>
              </div>
              { user_plan == 'premium' ? (
                <span>
                  <div className="d-flex justify-content-between mt-2">
                    <small>Saturday - premium questions (This month)</small>
                    <small>{premium_questions.used + '/' + premium_questions.max}</small>
                  </div>
                  <div className="progress progress-lg mt-2">
                    <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': premium_questions_percentage() + '%'}}>{premium_questions_percentage() + '%'}</div>
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <small>Lima - premium questions (This month)</small>
                    <small>{premium_analyst_questions.used + '/' + premium_analyst_questions.max}</small>
                  </div>
                  <div className="progress progress-lg mt-2">
                    <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(premium_analyst_questions.used, premium_analyst_questions.max) + '%'}}>{questions_percentage(premium_analyst_questions.used, premium_analyst_questions.max) + '%'}</div>
                  </div>


                  <div className="d-flex justify-content-between mt-2">
                    <small>June - premium questions (This month)</small>
                    <small>{premium_sec_filing_questions.used + '/' + premium_sec_filing_questions.max}</small>
                  </div>
                  <div className="progress progress-lg mt-2">
                    <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': questions_percentage(premium_sec_filing_questions.used, premium_sec_filing_questions.max) + '%'}}>{questions_percentage(premium_sec_filing_questions.used, premium_sec_filing_questions.max) + '%'}</div>
                  </div>
                </span>
              ) : null}
            </div>
            { (user_plan == 'free' || user_plan == 'premium') ? (
              <div className='mt-2'>
                <p className="card-description"><small>{profile.earnings_call_usage_meter.next_steps} <a href="/pricing">here</a>.</small></p>
              </div>
            ) : null}
          </div>
        </div>
      </p>
    </div>
  );
}

export default AiAssistantUsage;
